/**
 * Single TanStack Query QueryClient instance for the whole app.
 *
 * Defaults tuned for an admin/staff CRUD app on a low-volume backend:
 *  - staleTime 30s — most lists tolerate brief staleness
 *  - retry 1     — flaky networks shouldn't blast the API
 *  - refetchOnWindowFocus false — we trigger refetches on mutation success
 */

import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});

